module.exports = __webpack_public_path__ + "85d4791bcc1bfd58badc1dababc89c74.glb";